import React, { FC } from 'react';
import { styled } from '@material-ui/core';
import { Environment, getEnvironment } from '@/services/config';
import { getAuthTokenFromStorage } from '@/services/utils';

const StyledLink = styled('a')({
  cursor: 'pointer',

  '&:hover': {
    color: 'rgba(0, 0, 0, 0.87)',
    'background-color': 'rgb(229, 229, 229)',
  },
});

interface Props {
  propertyId: string;
}

const ProductConfigurationLink : FC<Props> = ({ propertyId, children }) => {
  const environment = getEnvironment();
  const authToken = getAuthTokenFromStorage();
  let link = '';

  switch (environment) {
    case Environment.DEVELOPMENT: {
      // If you need to test both houstons at the same time, run the second one on a different port
      link = `http://localhost:5003/login?redirect=/properties/${propertyId}/tasks#access_token=${authToken}`;

      break;
    }

    case Environment.STAGING: {
      link = `https://houston2.staging-bobw.com/login?redirect=/properties/${propertyId}/tasks#access_token=${authToken}`;

      break;
    }

    case Environment.PRODUCTION: {
      link = `https://houston2.bobw.co/login?redirect=/properties/${propertyId}/tasks#access_token=${authToken}`;

      break;
    }

    case Environment.DUKE_NUKEM: {
      link = `https://houston2.dukenukem.test-bobw.com/login?redirect=/properties/${propertyId}/tasks#access_token=${authToken}`;

      break;
    }
  }

  return (
    <StyledLink href={link} target="_blank">
      {children}
    </StyledLink>
  );
};

export default ProductConfigurationLink;
